import './jp/jp.js';

import './services/i18';

import React, {lazy, Suspense, useEffect} from 'react';
import { Redirect, Route } from 'react-router-dom';

import { IonApp, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.scss';
import './theme/jp.css';

import { SplashScreen } from '@capacitor/splash-screen';

import useAuth, { AuthProvider } from "./pages/auth/auth.context";

import AuthenticatedTabs from './AuthenticatedTabs';
const Auth = lazy(() => import('./pages/auth/auth'));

setupIonicReact({
  mode: 'ios',
  animated: true,
  hardwareBackButton: true,
  swipeBackEnabled: true,
  rippleEffect: true
});

interface IUserManager {
  setIsLoggedIn: Function;
  isLoggedIn: boolean;
}

const user: IUserManager = {
  setIsLoggedIn: () => {},
  isLoggedIn: false
};

export const UserContext = React.createContext<IUserManager>(user);

const IonicApp: React.FC = () => {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    (async () => {
      await SplashScreen.hide();

      await SplashScreen.show({
        autoHide: false,
      });

      await SplashScreen.show({
        showDuration: 2000,
        autoHide: true,
      })
    })();
  }, [])

  return (
    <IonApp>

      <Suspense fallback={ <>Loading..</> }>
        <IonReactRouter>
          <Route path='/auth'
            render = { () => isLoggedIn ? <Redirect to='/play' /> : <Auth /> }
          />
          <Route path='/login'
            render = { () => isLoggedIn ? <Redirect to='/play' /> : <Auth /> }
          />
          <Route path='/' component={ isLoggedIn ? AuthenticatedTabs : Auth } />
        </IonReactRouter>
      </Suspense>
    </IonApp>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <IonicApp />
    </AuthProvider>
  );
}

export default App;